import { useQueryStateContext } from '../../contexts';
import { useVisualComponentsContext } from '../../contexts/visualComponents';
import { useTranslation } from '../../hooks/useTranslation';
import { CountFilter, CountFilterType } from '../../types';

type EventCountFilterProps = {
  isInvalid?: boolean;
  setCountFilterType: (value: CountFilterType) => void;
  countFilterType: CountFilterType;
  onChange: (value: CountFilter) => void;
  value: CountFilter;
};

export const EventCountFilter = ({
  isInvalid = false,
  onChange,
  setCountFilterType,
  value,
  countFilterType,
}: EventCountFilterProps) => {
  const { t } = useTranslation();
  const { RequirementCountFilterInput: VisualComponent } = useVisualComponentsContext();
  const { isReadOnly = false } = useQueryStateContext();

  return (
    <VisualComponent
      hasError={isInvalid}
      isDisabled={isReadOnly}
      onChange={onChange}
      setCountFilterType={setCountFilterType}
      placeholder={t('v2.requirementBuilder.eventCountFilterPlaceholder')}
      value={value}
      countFilterType={countFilterType}
    />
  );
};
